// src/pages/website/AboutPage.js
import React from 'react';
import Navbar from '../../components/website/Navbar';
import Footer from '../../components/website/Footer';
import './website.css';

export default function AboutPage() {
  return (
    <div className="website-page">
      <Navbar />

      <section style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #0066cc 100%)',
        color: '#fff', padding: '60px 5%', textAlign: 'center'
      }}>
        <h1 style={{ fontSize: 40, fontWeight: 800, marginBottom: 12 }}>About CivicSetu</h1>
        <p style={{ fontSize: 17, opacity: 0.85, maxWidth: 560, margin: '0 auto' }}>
          Bridging the gap between emergencies and help
        </p>
      </section>

      <section className="section">
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <div className="section-label">Our Mission</div>
          <h2 style={{ fontSize: 28, fontWeight: 700, margin: '12px 0 16px' }}>
            No More Unidentified Accident Victims
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.8, color: '#444', marginBottom: 24 }}>
            India loses over 1.5 lakh lives to road accidents every year. A significant number
            of these deaths happen because first responders cannot identify the victim or contact
            family members during the critical golden hour.
          </p>
          <p style={{ fontSize: 16, lineHeight: 1.8, color: '#444', marginBottom: 24 }}>
            CivicSetu was built to solve this problem. A simple QR code — attached to a vehicle,
            school bag, or ID card — can instantly connect first responders with family members
            and provide critical medical information.
          </p>
          <p style={{ fontSize: 16, lineHeight: 1.8, color: '#444' }}>
            Our goal is to make every Indian — from school children to senior citizens, from
            vehicles to pilgrims — identifiable and reachable in emergencies.
          </p>
        </div>
      </section>

      <section className="section section-alt">
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <div className="section-label">Our Values</div>
          <div className="features-grid" style={{ marginTop: 24 }}>
            {[
              { icon: '🔒', title: 'Privacy First', desc: 'We only share what is needed in emergencies. No home addresses, no sensitive data.' },
              { icon: '🤝', title: 'Accessible to All', desc: 'Works on any smartphone with a camera. No app needed for the person scanning.' },
              { icon: '🇮🇳', title: 'Built for India', desc: 'Designed around India\'s unique challenges, infrastructure and safety needs.' },
              { icon: '💡', title: 'Simple Technology', desc: 'No complex setup. Anyone can create and use a QR code in minutes.' },
            ].map((v, i) => (
              <div className="feature-card" key={i}>
                <div className="feature-icon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
